module.exports = __webpack_public_path__ + "static/img/ta.df7ff1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/icons/ta.png
// module id = 4nXm
// module chunks = 0